import { useEffect, useMemo, useState } from 'react';
import { useFilters } from './useFilters';

export const useLocalSort = (arr: any[], key: string, id?: string) => {
  const { getNestedFilters } = useFilters();
  const sortFilters = getNestedFilters(key);
  const currentSortFilters = id ? sortFilters[id]?.sortOrder : sortFilters?.sortOrder;
  const sortArray = (array: any[], asc: boolean, sortKey: string = 'score') => {
    if (asc) {
      return [...array]?.sort((a, b) => a[sortKey] - b[sortKey]);
    }
    return [...array]?.sort((a, b) => b[sortKey] - a[sortKey]);
  };

  const getThisNestSortFilters = useMemo(() => {
    if (currentSortFilters) {
      const [sortKey, value] = currentSortFilters.split(':');
      return { key: sortKey, value };
    }
    return { key: null, value: null };
  }, [currentSortFilters]);

  const prepareInitialArr = useMemo(() => {
    const { key, value } = getThisNestSortFilters;
    if (currentSortFilters) {
      return sortArray([...arr], value === 'asc', key);
    }
    return [...arr];
  }, [arr, currentSortFilters, getThisNestSortFilters]);

  type arrType = typeof arr;
  const [loading, setLoading] = useState(true);
  const [sortItems, setItemsSort] = useState<arrType>(prepareInitialArr);

  const sortByValue = (key: string, asc: boolean) => {
    if (asc) {
      const sortedArr = [...sortItems]?.sort((a, b) => a[key] - b[key]);
      return setItemsSort(sortedArr);
    }
    const sortedArr = [...sortItems]?.sort((a, b) => b[key] - a[key]);
    return setItemsSort(sortedArr);
  };

  useEffect(() => {
    setLoading(true);
    const { key, value } = getThisNestSortFilters;
    const name = key || 'score';
    const isAsc = value === 'asc';
    if (value === 'default' || value === null) {
      setItemsSort([...arr]);
      return setLoading(false);
    }
    sortByValue(name, isAsc);
    setLoading(false);
  }, [getThisNestSortFilters]);

  return { sortItems, getThisNestSortFilters, loading };
};
